import type { EmailTone } from './customerFollowUp/enums';

export type TemplateLanguage = 'FR' | 'EN';

export const TEMPLATE_LANGUAGES: readonly TemplateLanguage[] = ['FR', 'EN'];

/** Subject and body with the macros in their canonical `{{name}}` form. */
export interface CustomEmailTemplateContent {
    subject: string;
    body: string;
}

/** A null language means the company has no template written in it. */
export interface CustomEmailTemplateSetting {
    fr: CustomEmailTemplateContent | null;
    en: CustomEmailTemplateContent | null;
}

export const CUSTOM_TONE = 'CUSTOM' as const;

/** The email tone chips: the three AI tones plus the company's custom template. */
export type ToneChoice = EmailTone | typeof CUSTOM_TONE;

export const contentFor = (
    setting: CustomEmailTemplateSetting | null,
    language: TemplateLanguage,
): CustomEmailTemplateContent | null => (language === 'FR' ? setting?.fr : setting?.en) ?? null;

export const definedLanguages = (setting: CustomEmailTemplateSetting | null): TemplateLanguage[] =>
    TEMPLATE_LANGUAGES.filter(language => contentFor(setting, language) !== null);
